<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-10">
            Talent Profiling Guide
        </div>
        <div class="content margin-bottom-10">
            <a href="/question-set-b">
                <img :src="'images/mpower-new/career/back-arrow.png'" />
            </a>
        </div>
        <div class="content">
            <div class="talent-question-title margin-bottom-10 text-left">
                {{data[loadIndex].title}}
            </div>
            <div class="talent-question-desc line-height-normal text-left">
                {{data[loadIndex].description}} 
            </div>
        </div>
        <div class="content" v-for="(item,index) in data[loadIndex].question" :key="index">
            <div class="talent-category margin-bottom-10 text-left">
                {{item.section}}
            </div>
            <div v-for="(subitem,index) in item.question" :key="index">
                <div class="talent-left-wrapper">
                    <label class="talent-label text-left">
                        {{subitem.title}}
                    </label>
                </div>
                <div class="talent-right-wrapper">

                    <label v-if="item.section.toLowerCase()=='g' && subitem.index!='10'" :class="setg.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="setg" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_g[]" @change="check(setg,'g')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='g' && subitem.index=='10'" class="talent-option talent-option-text total_number_g">
                        <input v-model="setg" class="custom-input-text total_number_g" type="number" name='total_number_g' readonly>
                    </label>

                    <label v-if="item.section.toLowerCase()=='e' && subitem.index!='9'" :class="sete.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="sete" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_e[]" @change="check(sete,'e')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='e' && subitem.index=='9'" class="talent-option talent-option-text total_number_e">
                        <input v-model="sete" class="custom-input-text total_number_e" type="number" name='total_number_e' readonly>
                    </label>

                    <label v-if="item.section.toLowerCase()=='n' && subitem.index!='10'" :class="setn.includes('option'+subitem.index)?'talent-option label-highlight':'talent-option'">
                        <input v-model="setn" :value="'option'+subitem.index" class="custom-input" type="checkbox" name="interest_n[]" @change="check(setn,'n')">
                    </label>
                    <label v-if="item.section.toLowerCase()=='n' && subitem.index=='10'" class="talent-option talent-option-text total_number_n">
                        <input v-model="setn" class="custom-input-text total_number_n" type="number" name='total_number_n' readonly>
                    </label>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="talent-button-wrapper">
            <a @click="proceed()" class="generali-button-red">
                {{data[loadIndex].button}}
            </a>
        </div>
    </div>
</template>
<style scoped>
</style>
<script>
export default {
    name: "Question_set_c",
    data(){
        return {
            setg: [],
            sete: [],
            setn: [],
            conclusion: {},
            loadIndex: 0,
            data: [{
                "language": "en",
                "title": "II. Capability",
                "description": "Place a tick ( ✔ ) in the box against all the items that are true for you. You can tick as many as you want.",
                "question": [{
                    "section": "G",
                    "question": [{
                        "index": 1,
                        "title": "I know how to use a voltmeter"
                    },{
                        "index": 2,
                        "title": "I have operated power tools such as a drill press"
                    },{
                        "index": 3,
                        "title": "I can sew buttons on clothing"
                    },{
                        "index": 4,
                        "title": "I can read blueprints"
                    },{
                        "index": 5,
                        "title": "I can repair furniture"
                    },{
                        "index": 6,
                        "title": "I can make technical drawings"
                    },{
                        "index": 7,
                        "title": "I can make simple electrical repairs"
                    },{
                        "index": 8,
                        "title": "I can make simple plumbing repairs"
                    },{
                        "index": 9,
                        "title": "I can perform simple vehicle maintenance"
                    },{
                        "index": 10,
                        "title": "TOTAL no. of ticks"
                    }]
                },{
                    "section": "E",
                    "question": [{
                        "index": 1,
                        "title": "I understand how a loudspeaker works"
                    },{
                        "index": 2,
                        "title": "I can use a scientific calculator"
                    },{
                        "index": 3,
                        "title": "I can use a microscope"
                    },{
                        "index": 4,
                        "title": "I can identify three constellations of the stars"
                    },{
                        "index": 5,
                        "title": "I can describe the function of white blood cells"
                    },{
                        "index": 6,
                        "title": "I can interpret simple chemical formula"
                    },{
                        "index": 7,
                        "title": "I understand why man-made satellites don't fall to earth"
                    },{
                        "index": 8,
                        "title": "I have participated in a scientific fair or contest"
                    },{
                        "index": 9,
                        "title": "TOTAL no. of ticks"
                    }]
                },{
                    "section": "N",
                    "question": [{
                        "index": 1,
                        "title": "I can play a musical instrument"
                    },{
                        "index": 2,
                        "title": "I can participate in a singing choir"
                    },{
                        "index": 3,
                        "title": "I can perform as a musical soloist"
                    },{
                        "index": 4,
                        "title": "I can act in a play"
                    },{
                        "index": 5,
                        "title": "I can sketch people so that they can be recognized"
                    },{
                        "index": 6,
                        "title": "I can do a painting or sculpture"
                    },{
                        "index": 7,
                        "title": "I can make pottery"
                    },{
                        "index": 8,
                        "title": "I can design clothing, posters or furniture"
                    },{
                        "index": 9,
                        "title": "I write stories or poetry well"
                    },{
                        "index": 10,
                        "title": "TOTAL no. of ticks"
                    }]
                }],
                "answer": "Yes",
                "button": "Proceed"
            },{
                "language": "cn",
                "title": "II. 本领",
                "description": "在那些你胜任的领域里面画 （ ✔ ）。 你可以选择超过一个。",
                "question": [{
                    "section": "G",
                    "question": [{
                        "index": 1,
                        "title": "我知道如何使用电压表"
                    },{
                        "index": 2,
                        "title": "我曾操作电动工具，如钻床"
                    },{
                        "index": 3,
                        "title": "我可以缝补衣服"
                    },{
                        "index": 4,
                        "title": "我看得明白蓝图"
                    },{
                        "index": 5,
                        "title": "我可以修理家具"
                    },{
                        "index": 6,
                        "title": "我可以制造技术性绘画"
                    },{
                        "index": 7,
                        "title": "我可以进行简单的电器维修工作"
                    },{
                        "index": 8,
                        "title": "我可以进行简单的水管维修工作"
                    },{
                        "index": 9,
                        "title": "我可以进行简单的机械维修工作"
                    },{
                        "index": 10,
                        "title": "✔ 的数量"
                    }]
                },{
                    "section": "E",
                    "question": [{
                        "index": 1,
                        "title": "我了解扬声器的操作"
                    },{
                        "index": 2,
                        "title": "我会使用科学计算器"
                    },{
                        "index": 3,
                        "title": "我会使用显微镜"
                    },{
                        "index": 4,
                        "title": "我会辨认三个星座"
                    },{
                        "index": 5,
                        "title": "我可以解说白血球的功能"
                    },{
                        "index": 6,
                        "title": "我可以说明简单的化学程式"
                    },{
                        "index": 7,
                        "title": "我明白为什么人造卫星不会掉到地球上"
                    },{
                        "index": 8,
                        "title": "我曾参加科学展或比赛"
                    },{
                        "index": 9,
                        "title": "✔ 的数量"
                    }]
                },{
                    "section": "N",
                    "question": [{
                        "index": 1,
                        "title": "我会演奏一种乐器"
                    },{
                        "index": 2,
                        "title": "我会参与歌唱团"
                    },{
                        "index": 3,
                        "title": "我会表演乐器独奏"
                    },{
                        "index": 4,
                        "title": "我会进行角色扮演"
                    },{
                        "index": 5,
                        "title": "我会画出栩栩如生的人物素描"
                    },{
                        "index": 6,
                        "title": "我会绘画或雕像"
                    },{
                        "index": 7,
                        "title": "我会制造陶器"
                    },{
                        "index": 8,
                        "title": "我会设计衣裳、海报或家具"
                    },{
                        "index": 9,
                        "title": "我会些故事或写诗"
                    },{
                        "index": 10,
                        "title": "✔ 的数量"
                    }]
                }],
                "answer": "是",
                "button": "继续"
            },{
                "language": "bm",
                "title": "II. Kemampuan",
                "description": "Sila tanda ( ✔ ) di dalam kotak terhadap semua perkara-perkara yang benar untuk anda. Anda boleh tanda seberapa banyak yang anda mahu.",
                "question": [{
                    "section": "G",
                    "question": [{
                        "index": 1,
                        "title": "Saya tahu bagaimana untuk menggunakan voltmeter"
                    },{
                        "index": 2,
                        "title": "Saya pernah mengguna perkakasan kuasa seperti mesin gerudi"
                },{
                        "index": 3,
                        "title": "Saya boleh menjahit butang-butang pakaian"
                    },{
                        "index": 4,
                        "title": "Saya boleh membaca pelan induk"
                    },{
                        "index": 5,
                        "title": "Saya boleh memperbaiki perabot"
                    },{
                        "index": 6,
                        "title": "Saya boleh membuat lukisan teknikal"
                    },{
                        "index": 7,
                        "title": "Saya boleh memperbaiki elektrik yang mudah"
                    },{
                        "index": 8,
                        "title": "Saya boleh memperbaiki paip yang mudah"
                    },{
                        "index": 9,
                        "title": "Saya boleh melakukan penyelenggaran kendereaan yang mudah"
                    },{
                        "index": 10,
                        "title": "Bilangan ✔"
                    }]
                },{
                    "section": "E",
                    "question": [{
                        "index": 1,
                        "title": "Saya faham bagaimana pembesar suara berfungsi"
                    },{
                        "index": 2,
                        "title": "Saya boleh menggunakan kalkulator saintifik"
                    },{
                        "index": 3,
                        "title": "Saya boleh menggunakan mikroskop"
                    },{
                        "index": 4,
                        "title": "Saya dapat mengenal pasti tiga buruj bintang"
                    },{
                        "index": 5,
                        "title": "Saya boleh menerangkan fungsi sel-sel darah putih"
                    },{
                        "index": 6,
                        "title": "Saya boleh mentafsirkan formula kimia yang mudah"
                    },{
                        "index": 7,
                        "title": "Saya faham mengapa satelit buatan manusia tidak jatuh ke bumi"
                    },{
                        "index": 8,
                        "title": "Saya pernah menyertai pameran saintifik atau pertandingan"
                    },{
                        "index": 9,
                        "title": "Bilangan ✔"
                    }]
                },{
                    "section": "N",
                    "question": [{
                        "index": 1,
                        "title": "Saya boleh bermain alat muzik"
                    },{
                        "index": 2,
                        "title": "Saya boleh menyertai dalam koir nyanyian"
                    },{
                        "index": 3,
                        "title": "Saya boleh melakukan sebagai pemain solo muzik"
                    },{
                        "index": 4,
                        "title": "saya boleh berlakon dalam drama"
                    },{
                        "index": 5,
                        "title": "Saya boleh lakarkan orang supaya mereka boleh dikenal"
                    },{
                        "index": 6,
                        "title": "Saya boleh melukis atau mengukir"
                    },{
                        "index": 7,
                        "title": "Saya boleh membuat tembikar"
                    },{
                        "index": 8,
                        "title": "Saya boleh mereka pakaian, poster atau perabot"
                    },{
                        "index": 9,
                        "title": "Saya menulis cerita-cerita atau puisi dengan baik"
                    },{
                        "index": 10,
                        "title": "Bilangan ✔"
                    }]
                }],
                "answer": "Ya",
                "button": "Teruskan"
            }]
        }
    },
    mounted(){
        if(localStorage.getItem('talent_test')){
            try{
                this.conclusion = JSON.parse(localStorage.getItem('talent_test'))
                for(var a = 0; a < this.data.length; a++){
                    if(this.conclusion.language==this.data[a].language){
                        this.loadIndex = a
                    }
                }
            }
            catch(e){
                console.log(e)
                localStorage.removeItem('talent_test')
            }
        }
    },
    methods: {
        check(set,setname) {
            this.$el.querySelector(".total_number_"+setname).innerText = set.length;
        },
        proceed(){
            this.conclusion.g2 = 0;
            this.conclusion.e2 = 0;
            this.conclusion.n2 = 0;

            if(this.setg.length > 0){
                for(var g = 0 ; g < (this.setg.length); g++){
                    this.conclusion.g2 += 1;
                }   
            }
            if(this.sete.length > 0){
                for(var e = 0; e < this.sete.length; e++){
                    this.conclusion.e2 += 1;
                }
            }
            if(this.setn.length > 0){
                for(var n = 0; n < this.setn.length; n++){
                    this.conclusion.n2 += 1;
                }
            }
            localStorage.setItem('talent_test',JSON.stringify(this.conclusion))
            window.scrollTo(0,0);
            this.$router.push({path: 'question-set-d'})
        }
    }
}
</script>